import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

import type { PracticeAIImpactDataResponse } from './types';

const selectedViewStorage = createJSONStorage<string | null>(
  () => localStorage,
);

export const selectedViewAtom = atomWithStorage(
  'jotai-videa-ai-view',
  null,
  selectedViewStorage,
);

/**
 * Atom to store mocked AI Impact data for testing purposes.
 * When set, this data will be used instead of making an API call.
 */
export const mockAIImpactDataAtom = atom<PracticeAIImpactDataResponse | null>(
  null,
);
